

export const TabSecData = [
    {
      label: "Overview",
      link: "overview",
    },
    {
      label: "Curriculum",
      link: "curriculum",
    },
 
    {
      label: "Instructor",
      link: "instructor",
    },
 
    {
      label: "Reviews",
      link: "reviews",
    }
  ];